module.exports = __webpack_public_path__ + "img/831.bce6d9b5.png";